App.directive('applySameAddress', ['Config', function (Config) {

    var defaultFieldsKeys = ['street', 'apartment', 'number', 'city', 'zipCode', 'post'];

    function applySameAddressController() {
        var self = this;

        self.applySameAddress = function () {
            if (self.isApplied && self.addressToApply) {
                if (!self.currentAddress) {
                    self.currentAddress = {};
                }
                var toApply = angular.copy(self.addressToApply);
                self.fields.forEach(function (fieldKey) {
                    var valueToCopy = toApply[fieldKey];
                    // TODO-MZ
                    // if (fieldKey === 'zipCode') {
                    //     if (valueToCopy && valueToCopy.length) {
                    //         valueToCopy = valueToCopy.split('');
                    //         valueToCopy.splice(2, 0, "-");
                    //         valueToCopy = valueToCopy.join('');
                    //     }
                    // }
                    self.currentAddress[fieldKey] = valueToCopy;
                });
            }
        };

        self.$onInit = function () {
            self.fields = self.fields || angular.copy(defaultFieldsKeys);
            self.text = self.text || 'pracownika';
            self.isApplied = self.isApplied || false;
            if (self.isApplied) {
                self.applySameAddress();
            }
        };
    }
    applySameAddressController.$inject = [];

    return {
        controller: applySameAddressController,
        controllerAs: 'asa',
        bindToController: true,
        restrict: 'E',
        scope: {
            currentAddress: "=",
            addressToApply: "=",
            isApplied: "=",
            text: "@?",
            fields: "=?"
        },
        templateUrl: Config.TEMPLATES_DIR + 'Components/apply-same-address-tpl.html'
    };

}]);